import valueIn from '../../utils/valueIn';
import FilterType from './filterType';

export default FilterType({
    id: 'BOOLEAN',
    filterFunction: (allHotelIds, filterTree, currentFilterValues, segmentationState, filterId) => {
        let isFilterActive = false;

        if (!allHotelIds || !filterTree || !currentFilterValues || !segmentationState || !filterId) {
            return 0;
        }

        currentFilterValues.forEach((filterValue, key) => {
            const value = valueIn(filterValue, 'value');
            // console.log("Before")
            // console.log(filterId)
            // console.log(currentFilterValues.toJS())
            // console.log(filterTree.toJS())
            // console.log(segmentationState)
            if (value) {
                isFilterActive = true;

                const bucket = valueIn(filterTree, [filterId, key]) || [];

                // TODO: Maybe we should store these as lookups in the filtertree directly?
                const bucketLookup = {};
                bucket.forEach((hotelId) => {
                    bucketLookup[hotelId] = true;
                });

                const currentFilterBlocks = [];
                allHotelIds.forEach((hotelId) => {
                    if (bucketLookup[hotelId]) {
                        segmentationState.match[hotelId] = !segmentationState.block[hotelId];
                    } else {
                        currentFilterBlocks.push(hotelId);
                    }
                });

                currentFilterBlocks.forEach((hotelId) => {
                    Object.keys(segmentationState.potentials).forEach((filterId) => {
                        if (segmentationState.potentials[filterId][hotelId]) {
                            segmentationState.potentials[filterId][hotelId] = false; // This filter blocks another filters potential
                        }
                    });

                    segmentationState.block[hotelId] = true;
                    segmentationState.match[hotelId] = false;
                });
            }
        });
        // console.log("After")
        // console.log(segmentationState)
        return isFilterActive ? 1 : 0;
    }
});
